import { FC, useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

import { CredentialsSection } from "./customerio/CredentialsSection"
import { EventNamesSection } from "./customerio/EventNamesSection"
import { TemplatesSection } from "./customerio/TemplatesSection"
import { useConnectionStatus } from "./customerio/useConnectionStatus"
import { useSettings } from "./customerio/useSettings"
import { SettingsHistoryNote } from "./SettingsHistoryNote"
import { SettingsSectionActions } from "./SettingsSectionActions"

export const CustomerioTab: FC = () => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const { form, loading, saving, deleting, setField, setTemplate, setEventName, handleSave, handleDeleteCredentials, refetch } =
    useSettings()
  const { status, testing, runTest } = useConnectionStatus()
  const [historyKey, setHistoryKey] = useState(0)

  // auto-test on mount; runTest is stable (useCallback with [])
  useEffect(() => {
    runTest()
  }, [runTest])

  const handleSaveAndTest = async () => {
    await handleSave()
    setHistoryKey((key) => key + 1)
    runTest()
  }

  const handleResetDone = async () => {
    await refetch()
    setHistoryKey((key) => key + 1)
    runTest()
  }

  if (loading) {
    return (
      <section className="flex flex-col gap-6 mt-6">
        <h3 className="text-xl font-semibold mb-2 text-[rgba(6,7,21,1)] dark:text-white">{t("settings.customerio.title")}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">{t("common.loading")}</p>
      </section>
    )
  }

  return (
    <section className="flex flex-col gap-6 mt-6">
      <div>
        <h3 className="text-xl font-semibold mb-1 text-[rgba(6,7,21,1)] dark:text-white">{t("settings.customerio.title")}</h3>
        <SettingsHistoryNote target="customerio" refreshKey={historyKey} />
      </div>

      <CredentialsSection
        form={form}
        saving={saving}
        deleting={deleting}
        onFieldChange={setField}
        onDeleteCredentials={handleDeleteCredentials}
        status={status}
        onTest={runTest}
        testing={testing}
      />
      <TemplatesSection form={form} saving={saving} onTemplateChange={setTemplate} />
      <EventNamesSection form={form} saving={saving} onEventNameChange={setEventName} />

      <SettingsSectionActions
        onSave={handleSaveAndTest}
        saving={saving}
        resetTarget="customerio"
        resetLabel={t("settings.tabs.customerio")}
        onResetDone={handleResetDone}
      />
    </section>
  )
}
